<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-8 m-auto">
          <div class="account">
            <div class="account_item">
              <h3>Личные данные</h3>
              <div class="input_group">
                <div class="input_block">
                  <p>Имя</p>
                  <input :disabled="isDisabled" type="text" v-model="getUser.first_name">
                </div>
                <div class="input_block">
                  <p>Номер телефона</p>
                  <input :disabled="isDisabled" type="text" v-model="getUser.phone">
                </div>
                <div class="input_block">
                  <p>Почта</p>
                  <input :disabled="isDisabled" type="email" v-model="user.email">
                </div>

                <span :disabled="isDisabled" @click="updateUser(user)" class="btn btn-primary" :class="{ 'disabled' : isDisabled }">Сохранить</span>
              </div>
              <div v-if="null" class="account_item">
                <h3>Смена пароля</h3>
                <div class="input_group">
                  <div class="input_block">
                    <p>Старый пароль</p>
                    <input type="password">
                  </div>
                  <div class="input_block">
                    <p>Новый пароль</p>
                    <input type="text">
                  </div>
                  <div class="input_block">
                    <p>Повторите новый пароль</p>
                    <input type="text">
                  </div>
                </div>
                <span class="btn btn-primary">Сохранить</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "Account",
  // eslint-disable-next-line vue/no-unused-components
  methods: {
    ...mapActions([
      'updateUser',
      'getMe'
    ]),
    async getMeUser() {
      await this.getMe()
    },

    isAvailable(roles) {
      return this.meRoles.map(item => roles.includes(item)).includes(true)
    },
  },
  data: () => {
    return {
      user: {
        first_name: '',
        phone: '',
        email: '',
        deposit: 0,
      },
    }
  },
  computed: {
    ...mapGetters(['getUser', 'meRoles']),

    isDisabled() {
      return this.isAvailable(['moderator']);
    }
  },

  async created() {
    await this.getMeUser()
    this.user = this.getUser

  },
  mounted() {

  },
}
</script>

<style scoped>
.account {
  padding: 20px;
  margin-top: 50px;
  border-radius: 10px;
  box-shadow: 0 2px 6px 0 rgb(32 33 37 / 10%);
  border: 1px solid #ddd;
}

.account h3 {
  border-bottom: 1px dashed #ccc;
  color: #333;
  font-size: 24px;
  font-weight: 600;
}

.account .account_item {

  margin-bottom: 20px;
}

.input_group {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.input_block {
  width: 49%;
  margin: 10px 0;
  display: inline-block;
}

.input_block input {
  width: 100%;
  border-radius: 10px;
  border: 1px solid #ccc;
  outline: none;
  padding: 7px 10px;
  font-size: 14px;
}

.input_block p {
  margin-bottom: 5px;
}

.account .account_item span {
  width: 49%;
  border-radius: 10px;
  margin-top: 30px;
}

.disabled {
  opacity: 0.7;
  pointer-events: none;
}

</style>
